module.exports = "<app-cookie-banner></app-cookie-banner>\n<router-outlet></router-outlet>\n"